export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5806.655848e1.jpg";